import React, { useCallback, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from './Tooltip';
import { subscribeLiveConnections, getLiveConnection } from '../../utils/liveConnections';

/**
 * A small dot on a request TAB whose connection is live — so a WebSocket that keeps
 * running while you work in another tab is visible, not a surprise.
 * Renders nothing for a tab without a live connection.
 */
export default function LiveConnectionDot({ tabId }) {
  const { t } = useTranslation();
  const status = useSyncExternalStore(
    subscribeLiveConnections,
    useCallback(() => getLiveConnection(tabId).status, [tabId]),
  );
  if (status !== 'connected' && status !== 'connecting') return null;
  return (
    <Tooltip content={t(status === 'connected' ? 'liveConnection.connected' : 'liveConnection.connecting')} side="bottom">
      <span
        role="status"
        aria-label={t(status === 'connected' ? 'liveConnection.connected' : 'liveConnection.connecting')}
        className="flex-shrink-0 rounded-full"
        style={{ width: 6, height: 6, marginLeft: 4, background: status === 'connected' ? '#22c55e' : '#eab308' }}
      />
    </Tooltip>
  );
}
